import { Outlet, useMatch } from 'react-router';
import { ConnectionBanner } from '@/app/ConnectionBanner';
import { InboxScreen } from '@/screens/InboxScreen';
import styles from '@/app/AppShell.module.css';

/**
 * The two-pane layout Section 14 fixes for the web client: a 320 px inbox
 * column beside the active conversation at 900 px and wider, collapsing to one
 * screen at a time below that.
 *
 * The collapse is done with a CSS breakpoint plus a data attribute rather than
 * a JavaScript media query, so a resize never unmounts and remounts a screen.
 * That matters more than it sounds: remounting the conversation would discard
 * the timeline's scroll position and reload its history, which is exactly the
 * "back navigation preserving scroll" that Section 14 requires be kept.
 *
 * Below 900 px both panes are still mounted; only one is displayed, chosen by
 * whether a conversation route is active.
 */
export function AppShell() {
  const conversationMatch = useMatch('/c/:conversationId');
  const groupMatch = useMatch('/c/:conversationId/group');
  const channelMatch = useMatch('/c/:conversationId/channel');
  const settingsMatch = useMatch('/settings');
  const detailActive =
    conversationMatch !== null ||
    groupMatch !== null ||
    channelMatch !== null ||
    settingsMatch !== null;

  return (
    <div className={styles.shell}>
      <ConnectionBanner />
      <div className={styles.columns} data-detail={detailActive ? 'active' : 'inactive'}>
        <div className={styles.inbox}>
          <InboxScreen />
        </div>
        <div className={styles.detail}>
          <Outlet />
        </div>
      </div>
    </div>
  );
}
